var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fairstone-plan-form',{attrs:{"mode":"edit"}})
}
var staticRenderFns = []

export { render, staticRenderFns }